import BaseApi from '../BaseApi';
// 站点右侧接口
export default class BatteryHolderApi extends BaseApi {
  // ***************************成本分析begin***************************
// 14.获取电池告警信息
async selectBatteryAlarmDetail(info) {
  return await this.get(`screenBatteryInfo/selectBatteryAlarmDetail`, info);
}
// 11.获取电池告警及故障率信息
async selectBatteryAlarmInfo(info) {
  return await this.get(`screenBatteryInfo/selectBatteryAlarmInfo`, info);
}
// 15.获取电池单体明细
async selectBatteryMonomerInfo(info) {
  return await this.get(`screenBatteryInfo/selectBatteryMonomerInfo`, info);
}
// 12.获取电池服务车辆
async selectBatteryServiceVehicle(info) {
  return await this.get(`screenBatteryInfo/selectBatteryServiceVehicle`, info);
}
// 13.获取电池充电记录
async selectBatteryChargingRecord(info) {
  return await this.get(`screenBatteryInfo/selectBatteryChargingRecord`, info);
}
  // ***************************成本分析end***************************
// 维修次数
async selectMaintainNum(info) {
  return await this.get(`screenFaultAlarm/selectMaintainNum`, info);
}
// 维修记录
async selectMaintainRecord(info) {
  return await this.get(`screenFaultAlarm/selectMaintainRecord`, info);
}


}
export const batteryHolderRight = new BatteryHolderApi();